import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

const AuthCallbackPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Handle the auth callback
    supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'PASSWORD_RECOVERY') {
        // Open auth modal with password reset view
        window.location.hash = '#auth-reset-password';
        window.dispatchEvent(new Event('open-auth'));
      } else if (event === 'SIGNED_IN') {
        // Redirect to home page for other auth events
        navigate('/', { replace: true });
      }
    });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-content-secondary">Processing authentication...</div>
    </div>
  );
};

export default AuthCallbackPage;